import { createAsyncThunk } from '@reduxjs/toolkit';
import {
  WCA_GET_CALL_SETTINGS,
  WCA_SET_CALL_SETTINGS,
  WCA_GET_WHATSAPP_PROFILE,
  WCA_SET_WHATSAPP_PROFILE,
  WCA_UPLOAD_PROFILE_PICTURE,
} from '../../../api/wca/wca.setting.services';

/* ================= CALL SETTINGS ================= */

export const wcaGetCallSettings = createAsyncThunk(
  'wca_settings/getCallSettings',
  async ({ metadataid }, thunkAPI) => {
    try {
      const response = await WCA_GET_CALL_SETTINGS(metadataid);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const wcaSetCallSettings = createAsyncThunk(
  'wca_settings/setCallSettings',
  async ({ metadataid, data }, thunkAPI) => {
    try {
      const response = await WCA_SET_CALL_SETTINGS(metadataid, data);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

/* ================= WHATSAPP PROFILE ================= */

export const wcaGetWhatsappProfile = createAsyncThunk(
  'wca_settings/getWhatsappProfile',
  async ({ metadataid }, thunkAPI) => {
    try {
      const response = await WCA_GET_WHATSAPP_PROFILE(metadataid);
      return response.data;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const wcaSetWhatsappProfile = createAsyncThunk(
  'wca_settings/setWhatsappProfile',
  async ({ metadataid, data }, thunkAPI) => {
    try {
      const response = await WCA_SET_WHATSAPP_PROFILE(metadataid, data);
      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);

export const wcaUploadProfilePicture = createAsyncThunk(
  'wca_settings/uploadProfilePicture',
  async ({ metadataid, file }, thunkAPI) => {
    try {
      const formData = new FormData();
      formData.append('file', file);
      formData.append('fieldName', 'profile_picture_handle');

      const response = await WCA_UPLOAD_PROFILE_PICTURE(metadataid, formData);

      return response;
    } catch (err) {
      return thunkAPI.rejectWithValue(err?.response?.data || err.message);
    }
  },
);
